module.exports = __webpack_public_path__ + "images/map-10e0a140000f94e958e0a5d58b080e5f.jpg";